import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { toastNotify } from 'app/notify/SnackbarUtils';

export function useRemoteMessage() {
  const { t } = useTranslation(['common']);
  const [params] = useSearchParams();
  const successMessage = params.get('message.success');
  const errorMessage = params.get('message.error');

  useEffect(() => {
    if (successMessage) {
      toastNotify.success(t(successMessage));
    }
  }, [successMessage, t]);

  useEffect(() => {
    if (errorMessage) {
      toastNotify.error(t(errorMessage));
    }
  }, [errorMessage, t]);
}
